import styled from 'styled-components';

export const OptionsWrapper = styled.div`
  margin-top: 8px;
`;
